<template>
    <div
            class="table_components"
            :class="tableConfig.searchParams && !retract ? 'retract-components': ''">
        <!-- 展开条件搜索 -->
        <el-tooltip
                v-if="tableConfig.searchParams && retract"
                effect="dark"
                content="展开条件搜索"
                placement="top">
            <i class="el-icon-s-tools retract-right" @click="retract = false"></i>
        </el-tooltip>
        <div class="search_params" :class="retract ? 'retract': ''" v-if="tableConfig.searchParams">
            <!-- 收起条件搜索 -->
            <el-tooltip effect="dark" content="收起条件搜索" placement="top">
                <i class="el-icon-back" @click="retract = true"></i>
            </el-tooltip>

            <h2 class="search_title">搜索条件筛选</h2>
            <el-divider>
                <i class="el-icon-search"></i>
            </el-divider>
            <div class="params">
                <slot name="searchParams"/>
            </div>
        </div>
        <div id="nav_table" ref="nav_table" class="nav_table">
            <div class="nav_left">
                <slot/>
            </div>
            <div class="nav_right">
                <!-- <el-input v-if="tableConfig.search" v-model="pagination.keyword" class="nav_item right-item" prefix-icon="el-icon-search" placeholder="请输入搜索的关键字" @focus="searchFocus" @blur="searchDisable = false" @input.native="handleKeywordChage()"/> -->
                <el-dropdown v-if="tableConfig.filter" :hide-on-click="false" trigger="click">
                    <el-button icon="el-icon-menu" type="primary"/>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item, index) in titleConfigOption" :key="index">
                            <el-checkbox v-model="item.visible" :label="item.title" @change="changeKey"/>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <slot name="navRight"/>
            </div>
        </div>

        <div class="block">
            <el-table
                    v-loading="loading"
                    ref="table"
                    :fit='true'
                    :max-height="height"
                    :data="tableData"
                    :key="key"
                    :stripe="true"
                    :row-style="{height:'50px'}"
                    :cell-style="{padding:'1px'}"
                    class="table"
                    style="width: 100%"

                    @selection-change="selectionChange"
                    @sort-change="sortChange"
            >
                <!-- 展开行 -->
                <el-table-column v-if="tableConfig.expand" type="expand">
                    <template slot-scope="props">
                        <slot name="expand" :row="props.row"/>
                    </template>
                </el-table-column>

                <!-- 序号 -->
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <!-- 行选择 -->
                <el-table-column v-if="tableConfig.selectCheck" type="selection" align="center"
                                 width="40"></el-table-column>
                <!-- 表格内容 -->
                <el-table-column
                        v-for="(item, index) in titleConfigShow"
                        :align="item.align"
                        :prop="item.field"
                        :key="index"
                        :show-overflow-tooltip='true'
                        :label="item.title"
                        :width="item.width"
                        :sortable="item.sortable ? 'custom' : false"
                >
                <template slot-scope="scope">

                  <span v-if="item.preview" class="preview-img">
                        <el-image :src="showPic(item, scope.row)" alt="首张图片" @click="previewImg(item, scope.row)"></el-image>
                  </span>
                  <span v-else @click="clickEvent(item, scope.row)" v-html="getLabelContent(item, scope.row)"></span>

                </template>

                </el-table-column>

                <!-- 操作按钮列 -->
                <el-table-column
                        v-if="optionConfig.children"
                        :align="optionConfig.align"
                        :width="optionConfig.width"
                        :label="optionConfig.title || '操作'"
                >
                    <template slot-scope="scope">
                        <div v-if="optionConfig.children.length < 1">
                            <el-button
                                    v-for="(item, index) in optionConfig.children"
                                    :disabled="typeof item.fuc !== 'function'"
                                    :style="{'color': item.color}"
                                    :class="[{'visibility': !hiddenFun(scope, item)}, optionConfig.style || 'block']"
                                    :key="index"
                                    :icon="item.icon"
                                    type="text"
                                    size="mini"
                                    @click="handleFuc(scope, item)"
                            >{{ item.title }}
                            </el-button>
                        </div>
                        <el-dropdown
                                v-else-if="isShowDropdown(scope)"
                                @command="handleFucMore($event, scope)"
                                placement="bottom"
                        >
              <span class="el-dropdown-link default-dropdown">
                <i class="el-icon-more icare-primary" style="padding: 1rem;"></i>
              </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                        v-for="(item, index) in optionConfig.children"
                                        :command="index"
                                        :split-button="true"
                                        :icon="item.icon"
                                        :key="index"
                                        :class="[{'visibility': !hiddenFun(scope, item)}]"
                                        :disabled="typeof item.fuc !== 'function'"
                                        :style="{'color': item.color}"
                                >{{ item.title }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <slot name="options" :row="scope.row"/>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页展示 -->
        <!-- 点击查看更多 -->
        <div class="last-pagination" v-if="tableConfig.pagination && storeCount > 0">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.page_no"
                    :page-sizes="[28, 30, 40, 50]"
                    :page-size="28"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="storeCount"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
    import {_debounce} from '@/utils'

    export default {
        props: {
            titleConfig: {
                type: Array,
                required: true,
                default: () => []
            },
            requestFun: {
                type: Function,
                default: () => {
                    return new Promise(resolve => {
                        resolve(false)
                    })
                },
            },
            params: {
                type: String,
                default: ''
            },
            tablePropData: {
                type: Object,
                default: () => {
                }
            },
            paginationConfig: {
                type: Object,
                default: () => {
                }
            },
            hiddenFun: {
                type: Function,
                default: () => {
                    return true
                }
            },
            layout: {
                type: String,
                default: 'pagination,export,search,filter'
            },
            exportConfig: {
                type: Array,
                default: () => {
                    return []
                }
            },
            autoSize: {
                type: Boolean,
                default: false
            },
            methodsData: String
        },
        data() {
            return {
                count: '',
                storeCount: '',
                tableData: [],
                loading: false,
                pagination: {
                    page_size: 28, //页面数据条数
                    page_no: 1 //页号
                },
                paginationLyout: 'total, sizes, prev, pager, next',
                searchDisable: false,
                key: 1,
                clickRes: '',
                exportLoading: false,
                config: {},
                imgList: [],
                tableHeight: undefined,
                retract: false,
                jumpLast: ['', '']
            }
        },
        computed: {
            titleConfigShow() {
                return this.titleConfig.filter(function (item) {
                    return item.visible === true
                })
            },
            optionConfig() {
                const arr = this.titleConfig.find(function (item) {
                    return item.option === true
                })
                return arr || []
            },
            titleConfigOption() {
                return this.titleConfig.filter(function (item) {

                    return item.option !== true
                })
            },
            height() {
                return this.autoSize ? this.tableHeight || undefined : undefined
            },
            // 返回表格展示信息
            tableConfig() {
                const arr = [
                    'pagination',
                    'export',
                    'search',
                    'searchParams',
                    'filter',
                    'selectCheck',
                    'expand'
                ]
                let res = {}
                this.layout
                    .replace(/\s/g, '')
                    .split(',')
                    .forEach(item => {
                        if (arr.indexOf(item) >= 0) {
                            res[item] = true
                        }
                    })
                return res
            },
            countPage() {
                return Math.ceil(this.storeCount / this.pagination.page_size)
            }
        },
        watch: {
            requestFun(val) {
                // console.log(val)
                this.getTableData()
            },
            paginationConfig: {
                handler(newVal, oldVal) {
                    // console.log(newVal)
                    // console.log(oldVal)
                    this.pagination.page_no = 1
                    this.getTableData()
                },
                deep: true
            }
        },
        mounted() {
            this.getTableData()
            const height = this.$refs.nav_table.offsetHeight
            this.tableHeight = document.body.offsetHeight - 100 - height
        },
        methods: {
            isShowDropdown(scope) {
                let show = false
                for (let i = 0; i < this.optionConfig.children.length; i++) {
                    const ele = this.optionConfig.children[i]
                    if (this.hiddenFun(scope, ele)) {
                        show = true
                        break
                    }
                }
                return show
            },
            showPic(item, row) {
                let imgList = item.previewFun(row).find(e => {
                    if (e) return e
                })
                return imgList + '?x-oss-process=image/resize,m_fill,h_60,w_60'
            },
            // 点击"图片图标"显示大图
            previewImg() {
                // let arr = item.previewFun(row)
                // this.imgList = arr
                // setTimeout(() => {
                //   this.$refs.viewer.$viewer.show()
                // }, 100)
            },
            // 改变排序
            sortChange(sort) {
                this.pagination.order_by = sort.prop ? sort.prop : ''
                this.pagination.sort_type = sort.order === 'ascending' ? 'ASC' : 'DESC'
                this.getTableData()
            },
            changeKey() {
                this.key += 1
            },
            // 点击跳转页数
            handleCurrentChange(val) {
                this.pagination.page_no = val
                this.getTableData()
            },
            handleSizeChange(val) {
                this.pagination.page_size = val
                this.getTableData()
            },
            // 获取表格列表数据
            getTableData(f) {
                if (typeof this.requestFun !== 'function') {
                    this.$message.warning('接口出现错误,请联系管理员')
                    return
                }
                if (f === 'first') {
                    this.tableData = []
                    this.pagination.last = ''
                    this.pagination.page_no = 1
                }
                this.loading = true
              let str = JSON.stringify(Object.assign(this.paginationConfig));
                const params = {
                    func: this.methodsData,
                    page_size: this.pagination.page_size, //页面数据条数
                    page_no: this.pagination.page_no, //页号
                    params: str
                }

                this.requestFun(params)
                    .then(res => {
                        if (this.params === 'cells') {
                            this.count = res.page.count
                            this.$emit('getCount', this.count)
                        }
                        if (this.params === '') {
                            this.tableData = res.result
                        } else {
                            this.tableData = res.result[this.params]
                        }
                        this.storeCount = Number(res.count)
                        this.loading = false
                    })
                    .catch(err => {
                        if (err.message !== 'cancel' || err.message !== '取消') {
                            this.loading = false
                        }
                    })
            },
            getLabelContent(item, row) {
                const title = row[item.field]
                if (item.isPic === true&&row[item.field]!="") {
                    return `<div style="text-align: center"><img src="${row[item.field] ||
                    'xx'}" width="50px" height="50px"></div>`
                }
                if (typeof item.fuc === 'function') {
                    return item.fuc(title, item, row)
                } else {
                    if (item.fields) {
                        return this.IntegrateInformation(item, row)
                    }
                    if (title === 0) return title
                    return title || '-'
                }
            },
            IntegrateInformation(item, row) {
                let arr = ''
                for (var key in item.fields) {
                    const key_arr = key.replace(' ', '').split(',')
                    arr += `${item.fields[key] ? item.fields[key] + '：' : ''}`
                    let res = ''
                    key_arr.forEach((ele, index) => {
                        res += `${index > 0 && res !== '' && row[ele] ? ' - ' : ''} ${row[
                            ele
                            ] || ''}`
                    })
                    arr += (res.trim() || ' - ') + '<br/>'
                }
                return arr
            },
            handleFuc(scope, item) {
                if (typeof item.fuc === 'function') {
                    item.fuc(scope.row, scope.$index, item, this.tableData)
                }
            },
            handleFucMore(event, scope) {
                const item = this.optionConfig.children[event]
                if (typeof item.fuc === 'function') {
                    item.fuc(scope.row, scope.$index, item, this.tableData)
                }
            },
            handleTitle(scope, item) {
                if (typeof item.title === 'function') {
                    return item.title(scope.row, scope.$index, item, this.tableData)
                }
                return item.title
            },
            refresh() {
                this.getTableData()
                this.$refs.table.clearSelection()
            },
            clearSelection() {
                this.$refs.table.clearSelection()
            },
            // 分页大小改变
            limitChange() {
                this.pagination.page_no = 1
                this.jumpLast = ['', '', '']
                this.getTableData()
            },
            // 搜索刷新表格数据页面
            handleKeywordChage: _debounce(function () {
                this.getTableData()
                this.$emit('KeywordChange', this.pagination.keyword)
            }, 500),

            selectionChange(selection) {
                this.$emit('selectionChange', selection)
            },

            // 点击事件
            clickEvent(item, row) {
                if (typeof item.clickFuc === 'function') {
                    this.clickRes = item.clickFuc(row)
                }
            },
            //表格双击事件
            // handleDblclick(row) {
            //   this.$emit('handleDblclick', row)
            // },
            // last-pagination跳转
            jumpFun(action) {
                if (action === 'pre') {
                    //前一页
                    if (this.pagination.page_no <= 1) return
                    this.pagination.page_no--
                    this.getTableData()
                } else if (action === 'next') {
                    //下一页
                    if (this.pagination.page_no >= this.countPage) return
                    this.pagination.page_no++
                    this.getTableData()
                }
            },

            // 返回首页
            returnIndex() {
                this.pagination.page_no = 1
                this.getTableData()
            }
        }
    }
</script>

<style>
    .table_components .el-table__row td {
        border: none;
    }

    .table_components .el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: rgba(255, 255, 255 0.1);
    }

    .table_components .el-table__body-wrapper::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 3px;
    }

    .el-table th.is-leaf,
    .el-table td {
        border-color: #e2e2e2;
    }

    /*.el-table--striped .el-table__body tr.el-table__row--striped td {*/
    /*    background: #f5f7fa;*/
    /*}*/

    .nav_left > div {
        margin-right: 0.3rem;
        margin-bottom: 0.3rem;
    }

    .table .el-divider__text {
        background: #fff;
    }
</style>

<style lang="scss" scoped>
    .last-pagination {
        text-align: center;
        font-size: 13px;
        color: #606266;

        & > span {
            padding: 0 0.6rem;
        }

        .disabled_nav {
            cursor: not-allowed !important;
        }

        .last-num {
            display: inline-block;
            text-align: center;

            & > div {
                display: inline-block;
                width: 30px;
                line-height: 28px;
                border-radius: 5px;
                cursor: pointer;
                margin: 0 0.4rem;
            }

            .last-page {
                cursor: initial;
                background: #1890ff;
                color: #fff;
            }
        }

        .last-first {
            cursor: pointer;

            &:hover {
                color: #1890ff;
            }
        }

        .last-select {
            width: 100px;
        }
    }

    .table_components {
        position: relative;
        transition: padding-left 0.3s;

        .el-image {
            cursor: pointer;
        }

        .search_params {
            position: absolute;
            left: 0;
            top: 0;
            width: 240px;
            overflow: hidden;
            min-height: 600px;
            background: #fff;
            height: calc(100% - 53px);
            border-radius: 5px;
            transition: width 0.3s;

            .params {
                height: calc(100% - 80px);
                overflow: auto;
                width: calc(100% + 18px);
                padding-right: 18px;
            }

            .el-icon-back {
                position: absolute;
                right: 16px;
                top: 16px;
                cursor: pointer;
                color: #409eff;
            }

            .el-divider__text {
                background: #fff;
            }

            .search_title {
                margin: 0;
                padding-top: 1rem;
                text-align: center;
                font-size: 14px;
                color: #606266;
            }
        }

        .retract {
            width: 0;
        }

        .retract-right {
            cursor: pointer;
            font-size: 24px;
            position: absolute;
            left: -12px;
            top: 300px;
            z-index: 2;
            transition: 0.3s;
            color: #606266;

            &:hover {
                color: #409eff;
                transform: rotate(90deg) scale(1.2);
                left: -6px;
            }
        }
    }

    .retract-components {
        padding-left: 260px;
    }

    .default-dropdown {
        cursor: pointer;
        color: #409eff;
    }

    .pagination {
        text-align: right;
    }

    .right-item {
        margin-right: 0.3rem;
    }

    .nav_table {
        overflow: hidden;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
    }

    .nav_left {
        flex: 1;
    }

    .nav_left > p {
        margin-right: 0.3rem;
        margin-bottom: 0.3rem;
    }

    .nav_left > .el-button {
        margin-right: 0.3rem;
        margin-left: 0;
    }

    .nav_right .el-input {
        width: auto;
    }

    button.block {
        margin: 0 5px;
        text-align: center;
        padding: 0;
    }

    .visibility {
        display: none;
    }

    .table {
        border-radius: 8px;
        box-shadow: 0 0 5px 5px #f2f2f2;
    }

    .table > > > .cell .caret-wrapper {
        height: 23px;
    }

    .table > > > .cell .ascending {
        top: -1px;
    }

    .table > > > .cell .descending {
        bottom: 1px;
    }

    .preview-img i {
        font-size: 40px;
        color: #909399;
        cursor: pointer;
        transition: 0.3s;
    }

    .preview-img i:hover {
        color: #409eff;
    }

    .hidden {
        display: none;
    }

    ///* 选中某行时的背景色*/
    ///deep/  .el-table__body tr.current-row > td {
    //  background-color: #C0C4CC !important;
    //}


    /*鼠标移入某行时的背景色*/
    /deep/  .el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #C0C4CC;
    }


</style>
